<div class="modal-header" *transloco="let t; prefix: 'parts.modals'">
  <h5 class="modal-title">{{ t('addPart.title') }}</h5>
  <button type="button" class="btn-close" [attr.aria-label]="'common.close' | transloco" (click)="closeModal()">
    <i class="ph ph-x"></i>
  </button>
</div>

<div class="modal-body" *transloco="let t; prefix: 'parts.modals'">
  <form [formGroup]="form" (ngSubmit)="onSubmit()">
    <div class="form-group">
      <label>{{ t('fields.partName') }} <span class="required">*</span></label>
      <input class="form-control" type="text" formControlName="partName" [placeholder]="t('placeholders.enterPartName')" />
    </div>

    <div class="form-row">
      <div class="form-group third-width">
        <label>{{ t('fields.make') }} <span class="required">*</span></label>
        <div ngbDropdown #makeDropdown="ngbDropdown" class="custom-dropdown" [autoClose]="'outside'">
          <button type="button" class="btn form-control dropdown-toggle" ngbDropdownToggle [disabled]="isMakesLoading">
            <div class="d-flex flex-row justify-content-between dropdown-inner">
              <span class="align-middle value-text" [class.has-value]="!!form.get('make')?.value">{{ makeLabel }}</span>
              <i class="ph ph-caret-down lh-base"></i>
            </div>
          </button>

          <div ngbDropdownMenu>
            <div class="d-flex flex-column">
              @if (isMakesLoading) {
                <div class="dropdown-loading">
                  <span class="spinner-border dropdown-loading-spinner" aria-hidden="true"></span>
                  <span>{{ t('dropdown.loadingMakes') }}</span>
                </div>
              } @else {
                <div class="dropdown-search">
                  <input
                    type="text"
                    class="form-control"
                    [placeholder]="t('dropdown.searchMake')"
                    [value]="makeSearchTerm"
                    (input)="makeSearchTerm = $any($event.target).value"
                    (click)="$event.stopPropagation()" />
                </div>

                @for (option of filteredMakeOptions; track option.value) {
                  <button type="button" class="btn btn-outline" ngbDropdownItem (click)="onSelect('make', option.value, $event); makeDropdown.close()">
                    {{ option.label }}
                  </button>
                }

                @if (filteredMakeOptions.length === 0) {
                  <div class="dropdown-empty">{{ t('dropdown.noMakesFound') }}</div>
                }
              }
            </div>
          </div>
        </div>
      </div>

      <div class="form-group third-width">
        <label>{{ t('fields.model') }} <span class="required">*</span></label>
        <div ngbDropdown #modelDropdown="ngbDropdown" class="custom-dropdown" [autoClose]="'outside'">
          <button type="button" class="btn form-control dropdown-toggle" ngbDropdownToggle [disabled]="!isModelEnabled">
            <div class="d-flex flex-row justify-content-between dropdown-inner">
              <span class="align-middle value-text" [class.has-value]="!!form.get('model')?.value">{{ modelLabel }}</span>
              <i class="ph ph-caret-down lh-base"></i>
            </div>
          </button>

          <div ngbDropdownMenu>
            <div class="d-flex flex-column">
              @if (isMakeLoading) {
                <div class="dropdown-loading">
                  <span class="spinner-border dropdown-loading-spinner" aria-hidden="true"></span>
                  <span>{{ t('dropdown.loadingModels') }}</span>
                </div>
              } @else {
                <div class="dropdown-search">
                  <input
                    type="text"
                    class="form-control"
                    [placeholder]="t('dropdown.searchModel')"
                    [value]="modelSearchTerm"
                    (input)="modelSearchTerm = $any($event.target).value"
                    (click)="$event.stopPropagation()" />
                </div>

                @for (option of filteredModelOptions; track option.value) {
                  <button type="button" class="btn btn-outline" ngbDropdownItem (click)="onSelect('model', option.value, $event); modelDropdown.close()">
                    {{ option.label }}
                  </button>
                }

                @if (filteredModelOptions.length === 0) {
                  <div class="dropdown-empty">{{ t('dropdown.noModelsFound') }}</div>
                }
              }
            </div>
          </div>
        </div>
      </div>

      <div class="form-group third-width">
        <label>{{ t('fields.productionYear') }} <span class="required">*</span></label>
        <div ngbDropdown class="custom-dropdown production-year-dropdown" [autoClose]="true">
          <div class="dropdown-input-wrapper">
            <input type="number" min="1900" class="form-control dropdown-toggle" formControlName="productionYear" ngbDropdownToggle [placeholder]="t('placeholders.selectYear')" />
            <i class="ph ph-caret-down lh-base"></i>
          </div>

          <div ngbDropdownMenu class="production-year-menu">
            <div class="d-flex flex-column">
              @for (option of productionYearOptions; track option.value) {
                <button type="button" class="btn btn-outline" ngbDropdownItem (click)="onSelect('productionYear', option.value, $event)">
                  {{ option.label }}
                </button>
              }
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="form-group">
      <label>{{ t('fields.partNumber') }} <span class="required">*</span></label>
      <input class="form-control" type="text" formControlName="partNumber" [placeholder]="t('placeholders.enterPartNumber')" />
    </div>

    <div class="form-group">
      <label>{{ t('fields.description') }}</label>
      <textarea class="form-control textarea" formControlName="description" rows="3" [placeholder]="t('placeholders.writeShortDescription')"></textarea>
    </div>

    <div class="form-group">
      <label>{{ t('fields.partType') }} <span class="required">*</span></label>
      <div ngbDropdown #partTypeDropdown="ngbDropdown" class="custom-dropdown" [autoClose]="'outside'">
        <button type="button" class="btn form-control dropdown-toggle" ngbDropdownToggle [disabled]="isPartTypesLoading">
          <div class="d-flex flex-row justify-content-between dropdown-inner">
            <span class="align-middle value-text" [class.has-value]="!!form.get('partType')?.value">{{ partTypeLabel }}</span>
            <i class="ph ph-caret-down lh-base"></i>
          </div>
        </button>

        <div ngbDropdownMenu>
          <div class="d-flex flex-column">
            @if (isPartTypesLoading) {
              <div class="dropdown-loading">
                <span class="spinner-border dropdown-loading-spinner" aria-hidden="true"></span>
                <span>{{ t('dropdown.loadingPartTypes') }}</span>
              </div>
            } @else {
              <div class="dropdown-search">
                <input
                  type="text"
                  class="form-control"
                  [placeholder]="t('dropdown.searchPartType')"
                  [value]="partTypeSearchTerm"
                  (input)="partTypeSearchTerm = $any($event.target).value"
                  (click)="$event.stopPropagation()" />
              </div>

              @for (option of filteredPartTypeOptions; track option.value) {
                <button type="button" class="btn btn-outline" ngbDropdownItem (click)="onSelect('partType', option.value, $event); partTypeDropdown.close()">
                  {{ option.label }}
                </button>
              }

              @if (filteredPartTypeOptions.length === 0) {
                <div class="dropdown-empty">{{ t('dropdown.noPartTypesFound') }}</div>
              }
            }
          </div>
        </div>
      </div>
    </div>

    <div class="form-group">
      <label>{{ t('fields.category') }} <span class="required">*</span></label>
      <div ngbDropdown class="custom-dropdown" [autoClose]="true">
        <button type="button" class="btn form-control dropdown-toggle" ngbDropdownToggle>
          <div class="d-flex flex-row justify-content-between dropdown-inner">
            <span class="align-middle value-text" [class.has-value]="!!form.get('category')?.value">{{ categoryLabel }}</span>
            <i class="ph ph-caret-down lh-base"></i>
          </div>
        </button>

        <div ngbDropdownMenu>
          <div class="d-flex flex-column">
            @if (isCategoriesLoading) {
              <div class="dropdown-loading">
                <span class="spinner-border dropdown-loading-spinner" aria-hidden="true"></span>
                <span>{{ t('dropdown.loadingCategories') }}</span>
              </div>
            } @else {
              @for (option of categoryOptions; track option.value) {
                <button type="button" class="btn btn-outline" ngbDropdownItem (click)="onSelect('category', option.value, $event)">
                  {{ option.label }}
                </button>
              }
            }
          </div>
        </div>
      </div>
    </div>

    <div class="form-group">
      <label>{{ t('fields.storageLocation') }} <span class="required">*</span></label>
      <div ngbDropdown #storageDropdown="ngbDropdown" class="custom-dropdown" [autoClose]="'outside'">
        <button type="button" class="btn form-control dropdown-toggle" ngbDropdownToggle>
          <div class="d-flex flex-row justify-content-between dropdown-inner">
            <span class="align-middle value-text" [class.has-value]="!!form.get('storageLocation')?.value">{{ storageLocationLabel }}</span>
            <i class="ph ph-caret-down lh-base"></i>
          </div>
        </button>

        <div ngbDropdownMenu>
          <div class="d-flex flex-column">
            @if (isStorageLocationsLoading) {
              <div class="dropdown-loading">
                <span class="spinner-border dropdown-loading-spinner" aria-hidden="true"></span>
                <span>{{ t('dropdown.loadingStorageLocations') }}</span>
              </div>
            } @else {
              <div class="dropdown-search">
                <input
                  type="text"
                  class="form-control"
                  [placeholder]="t('dropdown.searchStorageLocation')"
                  [value]="storageLocationSearchTerm"
                  (input)="storageLocationSearchTerm = $any($event.target).value"
                  (click)="$event.stopPropagation()" />
              </div>

              @for (option of filteredStorageLocationOptions; track option.value) {
                <button type="button" class="btn btn-outline" ngbDropdownItem (click)="onSelect('storageLocation', option.value, $event); storageDropdown.close()">
                  {{ option.label }}
                </button>
              }

              @if (showNoStorageLocationSearchResult) {
                <div class="dropdown-empty">{{ t('dropdown.noStorageLocationsFound') }}</div>
              }

              @if (showNoStorageLocationsAction) {
                <button type="button" class="add-storage-location-inline" (click)="onAddStorageLocationClick()">
                  <span class="add-label">{{ t('dropdown.noStorageLocationsFound') }}</span>
                  <span class="add-icon-circle" aria-hidden="true">
                    <i class="ph ph-plus"></i>
                  </span>
                </button>
              }
            }
          </div>
        </div>
      </div>
    </div>

    <div class="form-row">
      <div class="form-group third-width">
        <label>{{ t('fields.reorderPoint') }} <span class="required">*</span></label>
        <div ngbDropdown class="custom-dropdown" [autoClose]="true">
          <div class="dropdown-input-wrapper">
            <input type="number" min="0" class="form-control dropdown-toggle" formControlName="reorderPoint" ngbDropdownToggle [placeholder]="t('placeholders.enterOrSelect')" />
            <i class="ph ph-caret-down lh-base"></i>
          </div>

          <div ngbDropdownMenu>
            <div class="d-flex flex-column">
              @for (option of reorderPointOptions; track option.value) {
                <button type="button" class="btn btn-outline" ngbDropdownItem (click)="onSelect('reorderPoint', option.value, $event)">
                  {{ option.label }}
                </button>
              }
            </div>
          </div>
        </div>
      </div>

      <div class="form-group third-width">
        <label>{{ t('fields.reorderQuantity') }} <span class="required">*</span></label>
        <div ngbDropdown class="custom-dropdown" [autoClose]="true">
          <div class="dropdown-input-wrapper">
            <input type="number" min="0" class="form-control dropdown-toggle" formControlName="reorderQuantity" ngbDropdownToggle [placeholder]="t('placeholders.enterOrSelect')" />
            <i class="ph ph-caret-down lh-base"></i>
          </div>

          <div ngbDropdownMenu>
            <div class="d-flex flex-column">
              @for (option of reorderQuantityOptions; track option.value) {
                <button type="button" class="btn btn-outline" ngbDropdownItem (click)="onSelect('reorderQuantity', option.value, $event)">
                  {{ option.label }}
                </button>
              }
            </div>
          </div>
        </div>
      </div>

      <div class="form-group third-width">
        <label>{{ t('fields.maximumQuantity') }} <span class="required">*</span></label>
        <div ngbDropdown class="custom-dropdown" [autoClose]="true">
          <div class="dropdown-input-wrapper">
            <input type="number" min="0" class="form-control dropdown-toggle" formControlName="maximumQuantity" ngbDropdownToggle [placeholder]="t('placeholders.enterOrSelect')" />
            <i class="ph ph-caret-down lh-base"></i>
          </div>

          <div ngbDropdownMenu>
            <div class="d-flex flex-column">
              @for (option of maximumQuantityOptions; track option.value) {
                <button type="button" class="btn btn-outline" ngbDropdownItem (click)="onSelect('maximumQuantity', option.value, $event)">
                  {{ option.label }}
                </button>
              }
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="reorder-alert">
      <div class="icon-wrap">
        <svg width="44" height="44" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M0 22C0 9.84974 9.84974 0 22 0C34.1503 0 44 9.84974 44 22C44 34.1503 34.1503 44 22 44C9.84974 44 0 34.1503 0 22Z" fill="#3873C9" />
          <path d="M22 12C16.486 12 12 16.486 12 22C12 27.514 16.486 32 22 32C27.514 32 32 27.514 32 22C32 16.486 27.514 12 22 12ZM23 27H21V21H23V27ZM23 19H21V17H23V19Z" fill="#F7F5F5" />
        </svg>
      </div>
      <div class="content">
        <p class="title">{{ t('addPart.reorderAlertTitle') }}</p>
        <p class="desc">{{ t('addPart.reorderAlertText') }}</p>
      </div>
    </div>

    <div class="modal-footer">
      <button type="button" class="cancel-btn" (click)="onCancel()">{{ 'common.cancel' | transloco }}</button>
      <button type="submit" class="save-btn" [disabled]="isLoading || isMakeLoading || form.invalid">
        @if (isLoading) {
          <span class="spinner-border"></span>
        } @else {
          <span>{{ t('actions.save') }}</span>
        }
      </button>
    </div>
  </form>
</div>